import store from '@/store'
import {
  connectionService,
  RACE_TIMEOUT,
  GEOFENCE_FETCH_URI,
  GEOFENCE_FIND_URI
} from '@leapsight/styleguide'
import { GlobalHelpers } from '@/helpers/mainExports'

const COUNTRY_POSITION = {
  ar: { lat: -38.45155, lng: -63.5988853 },
  cl: { lat: -34.8688531, lng: -109.4392245 },
  uy: { lat: -32.5882583, lng: -58.4244884 }
}

const geofenceType = {
  Circle: (data, map) => {    
    const lat = data.geometry.coordinates[0]
    const lng = data.geometry.coordinates[1]
    const radius = data.geometry.radius

    const options = {
      map,
      center: new google.maps.LatLng(lat, lng),
      title: data.properties.name,
      radius: radius,
      strokeColor: '#8079b7',
      strokeWeight: 2,
      strokeOpacity: 0.3,
      editable: false,
      fillColor: '#554da0',
      fillOpacity: 0.1
    }

    return new google.maps.Circle(options)
  },

  Polygon: (data, map) => {
    const coordinates = data.geometry.coordinates[0]
    const path = []
    for (let i = 0; i < coordinates.length; i++) {
      const element = coordinates[i]
      const latLng = { lng: element[0], lat: element[1] }
      path.push(latLng)
    }
    const options = {
      map,
      path: path,
      title: data.properties.name,
      strokeColor: '#8079b7',
      fillColor: '#554da0',
      editable: false,
      strokeOpacity: 0.3,
      strokeWeight: 2,
      fillOpacity: 0.1
    }

    return new google.maps.Polygon(options)
  }
}

const getGeofence = id => {
  return new Promise((resolve, reject) => {
    const connection = store.getters['authState/connection']
    const security = connectionService.createkwArgs()
    const args = id
    const kwArgs = {
      ...security
    }
    // kwArgs.query_spec = {
    //   _p: 'id,data.geometry.type,ata.geometry.coordinate,data.properties.name'
    // }
    const p1 = new Promise((resolve, reject) => {
      setTimeout(reject, RACE_TIMEOUT, [])
    })
    const p2 = new Promise((resolve, reject) => {
      connection.session
        .call(GEOFENCE_FETCH_URI, [args], kwArgs, {})
        .then(response => {
          resolve(response.args[0])
        })
        .catch(error => {
          reject(error)
        })
    })
    Promise.race([p1, p2])
      .then(value => {
        resolve(value)
      })
      .catch(error => {
        reject(error)
      })
  })
}

const getGeofences = (
  { _p } = { _p: 'id, data.geometry.coordinates, data.geometry.type, data.properties.name, function' }
) => {
  const connection = GlobalHelpers.getConnection()
  const security = connectionService.createkwArgs()
  const accountId = connectionService.getAccountId()
  const args = { account_id: accountId }
  const kwArgs = {
    ...security,
    query_spec: {
      _p
    }
  }
  const p1 = new Promise((resolve, reject) => {
    setTimeout(reject, RACE_TIMEOUT, [])
  })
  const p2 = new Promise((resolve, reject) => {
    connection.session
      .call(GEOFENCE_FIND_URI, [args], kwArgs, {})
      .then(response => {
        resolve(response.args[0].filter(geofence => !geofence.hasOwnProperty('function')))
      })
      .catch(error => {
        reject(error)
      })
  })
  return Promise.race([p1, p2])
    .then(value => {
      return value
    })
    .catch(error => {
      return error
    })
}

const geofenceOnMap = (geofences, map) => {
  const bounds = new google.maps.LatLngBounds()
  geofences.map(geofence => {
    const type = geofence.geometry.type
    const geofenceOnMap = geofenceType[type](geofence, map)

    if (type !== 'Circle')
      geofenceOnMap.getPaths().forEach(function(path) {
        path.forEach(function(latlng) {
          bounds.extend(latlng)
        })
      })
    else if (Boolean(geofenceOnMap.getRadius())) {
      const radius = geofenceOnMap.getRadius() * Math.pow(10, -5)
      const latCir = geofenceOnMap.getCenter().lat()
      const lngCir = geofenceOnMap.getCenter().lng()
      const pointX = latCir + radius
      const pointY = lngCir + radius
      const pointZ = latCir - radius
      const pointW = lngCir - radius
      const pathsCircle = [
        { lat: pointX, lng: lngCir },
        { lat: latCir, lng: pointY },
        { lat: pointZ, lng: lngCir },
        { lat: latCir, lng: pointW }
      ]
      pathsCircle.forEach(path => {
        bounds.extend(new google.maps.LatLng(path))
      })
    }

    map.fitBounds(bounds)

    geofenceOnMap.addListener('mouseover', () => {
      geofenceOnMap.setOptions({
        strokeColor: '#554da0',
        strokeOpacity: 1
      })

      map.getDiv().setAttribute('title', geofenceOnMap.get('title'))
    })

    geofenceOnMap.addListener('mouseout', () => {
      geofenceOnMap.setOptions({
        strokeColor: '#8079b7',
        strokeOpacity: 0.3
      })

      map.getDiv().removeAttribute('title')
    })

    store.dispatch('saveGeofenceOnMap', { geofenceOnMap })
  })
}

const getGeometryType = item => {
  const type = item.geometry.type.toLowerCase()
  return type
}

export default {
  COUNTRY_POSITION,
  getGeofence,
  getGeofences,
  geofenceOnMap,
  getGeometryType
}
